import React, { Component } from 'react';
import InsertBar from './insertBar';

class LinkEditBlock extends Component {
  state = {
    insertBarSwitch: false
  };

  handleInsertBarSwitch = specified => {
    let insertBarSwitch;
    if (!specified) {
      insertBarSwitch = !this.state.insertBarSwitch;
    } else {
      insertBarSwitch = specified;
    }
    this.setState({ insertBarSwitch });
  };

  render() {
    const { insertBarSwitch } = this.state;
    const { index, block, onBlockInputChange, onBlockTypeChange } = this.props;

    return (
      <div className='middle-navigator-edit-paragraph-container'>
        {insertBarSwitch ? (
          <InsertBar
            blockIndex={index}
            method={'insert'}
            onBlockTypeChange={onBlockTypeChange}
            onInsertBarSwitch={this.handleInsertBarSwitch}
          />
        ) : null}

        <div className='middle-navigator-edit-paragraph-upper-container'>
          <div className='middle-navigator-edit-paragraph-tag-container'>
            連結
          </div>
          <div className='middle-navigator-edit-snippet-right-icon-rightSide'>
            <div
              className='middle-navigator-edit-snippet-right-icon-container'
              onClick={() => this.handleInsertBarSwitch()}
            >
              {insertBarSwitch ? (
                <i className='fa fa-minus minusIcon' />
              ) : (
                <i className='fa fa-plus plusIcon' />
              )}
            </div>
            <div
              className='middle-navigator-edit-snippet-right-icon-container'
              onClick={() => onBlockTypeChange(index, 'remove', null)}
            >
              <i className='fa fa-trash trashIcon' />
            </div>
          </div>
        </div>
        <div className='middle-navigator-edit-paragraph-input link-container'>
          <div>
            <label className='label'>標籤:</label> &nbsp;
            <input
              name='label'
              type='text'
              className='label-input'
              onChange={e => onBlockInputChange(e, 'link', index, null)}
              value={block.label}
            />
          </div>

          <div style={{ marginTop: 10 }}>
            <label className='label'>URL:</label> &nbsp;
            <input
              name='url'
              type='text'
              className='label-input link'
              onChange={e => onBlockInputChange(e, 'link', index, null)}
              value={block.url}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LinkEditBlock;
